export default __webpack_public_path__ + "static/13-ae37cccd80d1b7af3b371509f0a4b27e.webp";